import EventTimer from './EventTimer';

export default EventTimer;
